import { render } from "./ModuleResult.vue?vue&type=template&id=8c0d3fdc&scoped=true"
import script from "./ModuleResult.vue?vue&type=script&lang=js"
export * from "./ModuleResult.vue?vue&type=script&lang=js"

import "./ModuleResult.vue?vue&type=style&index=0&id=8c0d3fdc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0d3fdc"]])

export default __exports__